import $axios from '../../settings/axios.js';
const state = {
  modal: false,
  input: {
    registrationplate: '',
    kilometers: '',
    department: '',
    services: '',
    date: '',
    option: '',
    time: '',
    firstname: '',
    lastname: '',
    address: '',
    zipcode: '',
    city: '',
    email: '',
    phone: '',
    agreement: '',
    note: ''
  },
  data: {
    general: '',
    tokenexpired: '',
    tokenpolicy: '',
    car: '',
    departments: '',
    dates: '',
    rentaldates: '',
    options: '',
    times: '',
    appointment: '',
    other: ''
  },
  reported: ''
};
const getters = { data: state => state };
const reportError = (payload, that) => {
  if (payload.send) {
    $axios.post('api/error/HandleError', payload.error).then(
      response => {
        that.dispatch('user/initLoading', false);
        that.dispatch('errors/setReported', response);
      },
      error => {
        that.dispatch('user/initLoading', false);
        that.dispatch('errors/setReported', error);
      }
    );
  } else {
    that.dispatch('user/initLoading', false);
  }
};
const actions = {
  resetErrors({ commit }) {
    commit('SET_MODAL', false);

    commit('SET_INPUT_REGISTRATIONPLATE', '');
    commit('SET_INPUT_KILOMETERS', '');
    commit('SET_INPUT_DEPARTMENT', '');
    commit('SET_INPUT_SERVICES', '');
    commit('SET_INPUT_DATE', '');
    commit('SET_INPUT_OPTION', '');
    commit('SET_INPUT_TIME', '');
    commit('SET_INPUT_FIRSTNAME', '');
    commit('SET_INPUT_LASTNAME', '');
    commit('SET_INPUT_ADDRESS', '');
    commit('SET_INPUT_ZIPCODE', '');
    commit('SET_INPUT_CITY', '');
    commit('SET_INPUT_EMAIL', '');
    commit('SET_INPUT_PHONE', '');
    commit('SET_INPUT_AGREEMENT', '');
    commit('SET_INPUT_NOTE', '');

    commit('SET_DATA_GENERAL', '');
    commit('SET_DATA_TOKEN_POLICY', '');
    commit('SET_DATA_CAR', '');
    commit('SET_DATA_DEPARTMENTS', '');
    commit('SET_DATA_SERVICES', '');
    commit('SET_DATA_DATES', '');
    commit('SET_DATA_OPTIONS', '');
    commit('SET_DATA_TIMES', '');
    commit('SET_DATA_APPOINTMENT', '');
    commit('SET_DATA_OTHER', '');
  },
  async submitPhone({ commit }, payload) {
    return await $axios.post(payload.endpoint, payload.data).then(response => {
      commit('SET_DONE', response.data);
    });
  },
  setModal({ commit }, payload) {
    commit('SET_MODAL', payload);
  },
  setInputRegistrationplate({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_INPUT_REGISTRATIONPLATE', payload.error.message);
  },
  setInputKilometers({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_INPUT_KILOMETERS', payload.error.message);
  },
  setInputDepartment({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_INPUT_DEPARTMENT', payload.error.message);
  },
  setInputServices({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_INPUT_SERVICES', payload.error.message);
  },
  setInputDate({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_INPUT_DATE', payload.error.message);
  },
  setInputOption({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_INPUT_OPTION', payload.error.message);
  },
  setInputTime({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_INPUT_TIME', payload.error.message);
  },
  setInputFirstname({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_INPUT_FIRSTNAME', payload.error.message);
  },
  setInputLastname({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_INPUT_LASTNAME', payload.error.message);
  },
  setInputAddress({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_INPUT_ADDRESS', payload.error.message);
  },
  setInputZipcode({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_INPUT_ZIPCODE', payload.error.message);
  },
  setInputCity({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_INPUT_CITY', payload.error.message);
  },
  setInputEmail({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_INPUT_EMAIL', payload.error.message);
  },
  setInputPhone({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_INPUT_PHONE', payload.error.message);
  },
  setInputAgreement({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_INPUT_AGREEMENT', payload.error.message);
  },
  setInputNote({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_INPUT_NOTE', payload.error.message);
  },
  setDataGeneral({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_DATA_GENERAL', payload.error.message);
  },
  setDataTokenExpired({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_DATA_TOKEN_EXPIRED', payload.error.message);
  },
  setDataTokenPolicy({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_DATA_TOKEN_POLICY', payload.error.message);
  },
  setDataCar({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_DATA_CAR', payload.error.message);
  },
  setDataDepartments({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_DATA_DEPARTMENTS', payload.error.message);
  },
  setDataServices({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_DATA_SERVICES', payload.error.message);
  },
  setDataDates({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_DATA_DATES', payload.error.message);
  },
  setDataRentalDates({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_DATA_RENTAL_DATES', payload.error.message);
  },
  setDataOptions({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_DATA_OPTIONS', payload.error.message);
  },
  setDataTimes({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_DATA_TIMES', payload.error.message);
  },
  setDataAppointment({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_DATA_APPOINTMENT', payload.error.message);
  },
  setDataOther({ commit }, payload) {
    reportError(payload, this);
    commit('SET_MODAL', payload.modal);
    commit('SET_DATA_OTHER', payload.error.message);
  },
  setReported({ commit }, payload) {
    commit('SET_REPORTED', payload);
  }
};
const mutations = {
  SET_MODAL(state, payload) {
    state.modal = payload;
  },
  SET_INPUT_REGISTRATIONPLATE(state, payload) {
    state.input.registrationplate = payload;
  },
  SET_INPUT_KILOMETERS(state, payload) {
    state.input.kilometers = payload;
  },
  SET_INPUT_DEPARTMENT(state, payload) {
    state.input.department = payload;
  },
  SET_INPUT_SERVICES(state, payload) {
    state.input.services = payload;
  },
  SET_INPUT_DATE(state, payload) {
    state.input.date = payload;
  },
  SET_INPUT_OPTION(state, payload) {
    state.input.option = payload;
  },
  SET_INPUT_TIME(state, payload) {
    state.input.time = payload;
  },
  SET_INPUT_FIRSTNAME(state, payload) {
    state.input.firstname = payload;
  },
  SET_INPUT_LASTNAME(state, payload) {
    state.input.lastname = payload;
  },
  SET_INPUT_ADDRESS(state, payload) {
    state.input.address = payload;
  },
  SET_INPUT_ZIPCODE(state, payload) {
    state.input.zipcode = payload;
  },
  SET_INPUT_CITY(state, payload) {
    state.input.city = payload;
  },
  SET_INPUT_EMAIL(state, payload) {
    state.input.email = payload;
  },
  SET_INPUT_PHONE(state, payload) {
    state.input.phone = payload;
  },
  SET_INPUT_AGREEMENT(state, payload) {
    state.input.agreement = payload;
  },
  SET_INPUT_NOTE(state, payload) {
    state.input.note = payload;
  },
  SET_DATA_GENERAL(state, payload) {
    state.data.general = payload;
  },
  SET_DATA_TOKEN_EXPIRED(state, payload) {
    state.data.tokenexpired = payload;
  },
  SET_DATA_TOKEN_POLICY(state, payload) {
    state.data.tokenpolicy = payload;
  },
  SET_DATA_CAR(state, payload) {
    state.data.car = payload;
  },
  SET_DATA_DEPARTMENTS(state, payload) {
    state.data.departments = payload;
  },
  SET_DATA_SERVICES(state, payload) {
    state.data.services = payload;
  },
  SET_DATA_DATES(state, payload) {
    state.data.dates = payload;
  },
  SET_DATA_RENTAL_DATES(state, payload) {
    state.data.rentaldates = payload;
  },
  SET_DATA_OPTIONS(state, payload) {
    state.data.options = payload;
  },
  SET_DATA_TIMES(state, payload) {
    state.data.times = payload;
  },
  SET_DATA_APPOINTMENT(state, payload) {
    state.data.appointment = payload;
  },
  SET_DATA_OTHER(state, payload) {
    state.data.other = payload;
  },
  SET_REPORTED(state, payload) {
    state.reported = payload;
  }
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
